export default __webpack_public_path__ + "static/media/playButton.206b0451.png";